import { useState } from 'react';
import type { WidgetConfig } from './lib/config';
import { t } from './lib/strings';
import { Modal } from './components/Modal';
import { LoginModal } from './components/LoginModal';

// Inline trigger on the product page. Logged-out → opens our login modal (fallback
// for themes without a native login popup); logged-in → opens the preview modal.
// Both render inside the same Shadow DOM.
export function App({ config }: { config: WidgetConfig }) {
  const [open, setOpen] = useState(false);
  const [loginOpen, setLoginOpen] = useState(false);

  return (
    <div className="aiw-trigger">
      <button
        type="button"
        className="aiw-btn"
        onClick={() => {
          if (config.loggedIn) setOpen(true);
          else setLoginOpen(true);
        }}
      >
        {t('trigger')}
      </button>
      <p className="aiw-muted aiw-small">{t('trigger_hint')}</p>

      {open && <Modal config={config} onClose={() => setOpen(false)} />}
      {loginOpen && <LoginModal config={config} onClose={() => setLoginOpen(false)} />}
    </div>
  );
}
